import React__default from 'react';
import { __spreadArrays } from '../../../../_virtual/_tslib.js';
import { useApplicationContext, Application } from '../../../../containers/ApplicationContext/index.js';
import { repeat } from 'lodash';
import classnames from 'classnames';
import MessageBubble from '../../../MessageBubble/index.js';
import { ConsumerRichCardEvents } from '../../../../containers/RichCardEventEmitter/ConsumerEventData/index.js';
import { useRichCardEventEmitter } from '../../../../containers/RichCardEventEmitter/index.js';
import { NumericRangeDisplayFacetType } from '../../../../generated/types.js';
import numeral from 'numeral';
import styles from './styles.css.js';

var SellableSearchPage = function SellableSearchPage(_a) {
  var _b;

  var message = _a.message,
      conversationStarterMessage = _a.conversationStarterMessage,
      sourcePage = _a.sourcePage;

  var convertFacetToString = function convertFacetToString(facet) {
    switch (facet.__typename) {
      case 'BucketedDisplayFacet':
        // capitalize each display name, and join bucket values with commas.
        return facet.buckets.map(function (value) {
          return value.displayName;
        }).join(', ');

      case 'NumericRangeDisplayFacet':
        var formatValue = function formatValue(value) {
          switch (facet.type) {
            case NumericRangeDisplayFacetType.USD_CURRENCY:
              // Use abbreviations for values of more than $10,000
              return numeral(value / 100).format('$0,0');

            default:
              // Scale the stored to it's actual representation, and include that many decimals
              var format = facet.scale > 0 ? "0,0." + repeat('0', facet.scale) : '0,0';
              return numeral(value * Math.pow(10, -facet.scale)).format(format);
          }
        };

        if (facet.lower && facet.upper) {
          return formatValue(facet.lower) + " - " + formatValue(facet.upper);
        } else if (facet.lower) {
          return "More Than " + formatValue(facet.lower);
        } else {
          return "Less Than " + formatValue(facet.upper);
        }

      default:
        return null;
    }
  };

  var richCardEventEmitter = useRichCardEventEmitter();
  var application = useApplicationContext().application;
  return React__default.createElement(MessageBubble, {
    message: message,
    fullWidth: true
  }, React__default.createElement("div", {
    className: styles.container
  }, React__default.createElement("div", {
    className: styles.copyRow
  }, "I'm searching for:"), React__default.createElement("div", {
    className: styles.innerMessageBubble
  }, React__default.createElement("div", {
    className: classnames(styles.container, (_b = {}, _b[styles.clickableTitle] = application === Application.CONSUMER, _b)),
    onClick: function onClick() {
      application === Application.CONSUMER && (richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
        type: ConsumerRichCardEvents.VIEW_SELLABLE_SEARCH_PAGE,
        categorySlug: sourcePage.category.slug,
        keywords: sourcePage.keywords || undefined,
        facets: sourcePage.facets
      }));
    }
  }, React__default.createElement("div", {
    className: styles.facetText
  }, sourcePage.keywords ? React__default.createElement(React__default.Fragment, null, sourcePage.keywords) : React__default.createElement(React__default.Fragment, null, __spreadArrays(["Category: " + sourcePage.category.pluralDisplayName], sourcePage.decoratedFacets.map(function (facet) {
    return facet.displayName + ": " + convertFacetToString(facet);
  })).join(' • '))))), React__default.createElement("div", {
    className: styles.copyRow
  }, "And I have a question:"), React__default.createElement("div", {
    className: styles.messageRow
  }, conversationStarterMessage)));
};

export default SellableSearchPage;
//# sourceMappingURL=index.js.map
